/*
 * This file is part of the Convergence API Server.
 *
 * (c) Convergence <https://convergence.finance/>
 */

import React from "react";
import MarkdownRenderer from "../../general/MarkdownRenderer";
import theme from "../../theme/3.0/theme";
import Link from "../../theme/3.0/Link";
import { getResourceParam } from "./SpecialInitiativesOverview";

const SpecialInitiative = ({ article }) => (
    <React.Fragment>
        <div className="container">
            <div className="row">
                <div className="col-md-3 order-md-2">
                    <img src={article.image} className={"logo"} width="250" />
                </div>
                <div className="col-md-9 order-md-1">
                    {<MarkdownRenderer content={article.pageContent} />}
                </div>
            </div>
            <div className={"window-links"}>
                {article.initiativeFeatures.indexOf("Resources") >= 0 ? (
                    <Link
                        routeKey={"knowledge"}
                        query={{
                            filters: getResourceParam(article.tags)
                        }}
                        label={"See Resources"}
                        size={"md"}
                        colour={"success"}
                        isButton
                    />
                ) : null}
                {/* {article.initiativeFeatures.indexOf("Deals") >= 0 ? (
                    <Link
                        routeKey={"special-initiatives-deals"}
                        params={{
                            pageSlug: article.pageSlug
                        }}
                        label={"View Transactions"}
                        size={"md"}
                        isButton
                    />
                ) : null} */}
            </div>
        </div>
        <style jsx>{`
            .logo {
                padding: 1rem;
            }
            .window-links {
                padding-top: 1rem;
            }
            .container {
                padding-top: 2rem;
                padding-bottom: 4rem;
            }
        `}</style>
    </React.Fragment>
);

export default SpecialInitiative;
